import { Form } from "formik";
import React from "react";
import ButtonGroupFooter from "../ButtonGroupFooter/ButtonGroupFooter";
import ArrayGroupComponent from "../ArrayGroupComponent/ArrayGroupComponent";
import ObjectGroupComponent from "../ObjectGroupComponent/ObjectGroupComponent";
import useCreateQuoteForm from "./useCreateQuoteForm";
import FocusError from "../FocusError";

export default function CreateQuoteForm(props) {
  const {
    activeStep,
    numberOfInsureds,
    formConfigJSON,
    disableBuy,
    handleBack,
    isLastStep,
  } = props;

  // console.log("numberOfInsureds: ", numberOfInsureds);
  const formSteps = formConfigJSON?.requestBody?.formFields?.fields?.map(
    (field) => field
  );

  const {} = useCreateQuoteForm();

  console.log("formSteps: ", formSteps);

  return (
    <Form autoComplete="off">
      <div className="form-container" style={{ marginBottom: "48px" }}>
        {Object.keys(formSteps[activeStep]).length > 0 &&
          (formSteps[activeStep].htmlElement.toLowerCase() === "array" ? (
            <ArrayGroupComponent
              inputArray={formSteps[activeStep]}
              numberOfInsureds={numberOfInsureds}
              productName={formConfigJSON.productName}
            />
          ) : formSteps[activeStep].htmlElement.toLowerCase() === "object" ? (
            <ObjectGroupComponent
              inputObject={formSteps[activeStep]}
              productName={formConfigJSON.productName}
            />
          ) : null)}
        <FocusError /> {/* Scroll to Error */}
      </div>

      {/* Back, next, submit button group */}
      <ButtonGroupFooter
        handleLeftButtonClick={handleBack}
        isLoading={disableBuy}
        rightButtonText={isLastStep() ? "Submit" : "Next"}
      />
    </Form>
  );
}
